module.exports = __webpack_public_path__ + "static/media/435381__pievarino__conference-lunch_01.b213576c.mp3";